"use strict";

$.widget("fotobook.weekNumbersPositionWidget", $.fotobook.containereditorbasecontrol, {
    calendar: null,
    _create: function(){
        this.calendar = Fotobook.containers.calendar;
        this._super();
    },
    _containerChanged: function(){
        var visible = this.calendar.weekNumbersAreVisible(this.options.container);

        this.element.toggleClass("click-to-show", !visible).toggleClass("click-to-hide", !!visible);
        this._super();
    },

    _processClick: function(event){
        var visible = this.element.hasClass("click-to-show"),
            position = visible ? this.calendar.SHOW_BEFORE : this.calendar.SHOW_NONE;
        return this.calendar.changeAttribute(this.options.container, "week_numbers_position", position);
    },
});
